






























// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import productApi from "@/api/productApi";
import { SaleBoom } from "@/model/product";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "SaleBom",
})
export default class SaleBomList extends Vue {
  @Prop({
    required: true,
  })
  itemCode;

  public list: SaleBoom[] = [];
  public loading = false;

  mounted() {
    if (this.itemCode) {
      this.getList();
    }
  }

  @Watch("itemCode")
  changedItemCode() {
    if (this.itemCode) {
      this.getList();
    } else {
      this.list = [];
    }
  }

  async getList() {
    this.list = await productApi.getSaleBom(this.itemCode);
    this.loading = true;
  }
}
